import React, { useContext } from "react";
import {
  CustomBadges,
  CustomInfoCard,
  CustomModal,
  TableHeader,
  UserInformation,
} from "../../../../components";
import Context from "../../../../context";
import Row from "../../../../components/CustomView/Row";
import Column from "../../../../components/CustomView/Column";
import TitleLine from "../../../../components/TitleLine";
import CustomLeaflet from "../../../../components/CustomLeaflet";
import values from "../../../../values";
import "./index.scss";
import utils from "../../../../utils";
import { ORDER_STATUS } from "../../../../values/dropdownItems";
import convertGregorianToJalali from "../../../../utils/convertGregorianToJalali";

const Detail = () => {
  const { setShowModal, showModal, selectedOrder } = useContext(
    Context?.OrderScreen
  );

  return (
    <section id="order-detail-modal">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "DETAIL"}
        minWidth={"35rem"}
        maxWidth={"40rem"}
      >
        <Row className="modal-user-info">
          <Column medium={8}>
            <UserInformation
              // avatar={selectedOrder?.logo}
              name={selectedOrder?.client?.firstName}
              lastName={selectedOrder?.client?.lastName}
              phoneNumber={selectedOrder?.client?.phoneNumber}
            />
          </Column>
          <Column medium={4}>
            <div style={{ textAlign: "center" }}>
              <CustomBadges
                title={
                  (" وضعیت سفارش: " +
                    ORDER_STATUS?.find(
                      (item) => item.value === selectedOrder?.status
                    )?.name) as string
                }
                type="warning"
              />
            </div>
          </Column>
        </Row>
        <TitleLine title="جزئیات سفارش" />
        <Row className="modal-user-info">
          <Column medium={12}>
            <div className="table-content-wrapper">
              <table>
                <TableHeader headers={values.tableHeaders.ORDER_INFO_HEADERS} />

                <tbody id="driver-table-body-container">
                  {selectedOrder?.orderInformation?.map(
                    (order: any, index: number) => {
                      return (
                        <tr key={`driver-${index}`}>
                          <td className="pointer">
                            {order?.categoryName
                              ? order?.categoryName
                              : "نامشخص"}{" "}
                          </td>
                          <td className="pointer">
                            {order?.weight ? order?.weight + " کیلوگرم" : "-"}{" "}
                          </td>
                          <td className="pointer">
                            {order?.pricePerKg
                              ? utils.convertNumberToPrice(
                                  Number(order?.pricePerKg)
                                ) + " تومان"
                              : "-"}{" "}
                          </td>
                          <td className="pointer">
                            {order?.price
                              ? utils.convertNumberToPrice(
                                  Number(order?.price)
                                ) + " تومان"
                              : "-"}{" "}
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </table>
            </div>
          </Column>
        </Row>
        <Row className="description">
          <Column medium={12}>
            {"توضیحات : " + selectedOrder?.description ? selectedOrder?.description : 'وارد نشده'}
          </Column>
        </Row>
        <TitleLine title="اطلاعات آدرس" />

        <Row className="address-cards">
          <Column medium={4} className="">
            <CustomInfoCard title="شهر" value={selectedOrder?.address?.county?.title}/><br/>
          </Column>
          <Column medium={8}>
            <CustomInfoCard
              title="تاریخ رجوع"
              value={
                utils.convertGregorianToJalali({
                  date: selectedOrder?.serviceDate,
                    format: "jDD / jMM / jYYYY",
                })}
            /><br/>
          </Column>
          <Column medium={12}>
            <CustomInfoCard
              title="زمان رجوع"
              value={`${selectedOrder?.workTime?.dayName} - ${selectedOrder?.workTime?.startTime} الی ${selectedOrder?.workTime?.endTime}`}
            /><br/>
          </Column>
          <Column medium={12}>
            <CustomInfoCard
              title="آدرس"
              value={selectedOrder?.address?.completeAddress}
            />
          </Column>
        </Row>
        <Row className="modal-user-info">
          <Column className="map">
            <CustomLeaflet
              defaultLat={selectedOrder?.address?.latitude}
              defaultLng={selectedOrder?.address?.longitude}
              defaultLatArea={selectedOrder?.address?.latitude}
              defaultLngArea={selectedOrder?.address?.longitude}
            />
          </Column>
        </Row>
      </CustomModal>
    </section>
  );
};

export default Detail;
